import { render, staticRenderFns } from "./collieryAll.vue?vue&type=template&id=c756c024&scoped=true"
import script from "./collieryAll.vue?vue&type=script&lang=js"
export * from "./collieryAll.vue?vue&type=script&lang=js"
import style0 from "./collieryAll.vue?vue&type=style&index=0&id=c756c024&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c756c024",
  null
  
)

export default component.exports